var styles = {
  "BottomSheet": "Online-Store-UI-BottomSheet_gekwl",
  "isModal": "Online-Store-UI-BottomSheet--isModal_l6nqo",
  "expanded": "Online-Store-UI-BottomSheet--expanded_1i7mv",
  "BottomSheetInterior": "Online-Store-UI-BottomSheet__BottomSheetInterior_ejpru",
  "paddingExtraTight": "Online-Store-UI-BottomSheet--paddingExtraTight_17rba",
  "paddingTight": "Online-Store-UI-BottomSheet--paddingTight_1rbmz",
  "paddingBaseTight": "Online-Store-UI-BottomSheet--paddingBaseTight_18wdk",
  "paddingBase": "Online-Store-UI-BottomSheet--paddingBase_ji8f4",
  "paddingLoose": "Online-Store-UI-BottomSheet--paddingLoose_10qpf",
  "paddingExtraLoose": "Online-Store-UI-BottomSheet--paddingExtraLoose_11clc"
};

export { styles as default };
